module.exports = __webpack_public_path__ + "img/ivTest_sub60.1d76ed44.png";